import { takeLatest, fork, cancel } from 'redux-saga/effects';
import types from '../redux/types.js';
import { loadProjects, updateUserDefaultProject, fetchTables } from './project.js';
import { fetchTemplates } from './template.js';
import { updateLocalStore } from './user.js';
import { fetchNotificationPreferences, fetchNotifications, fetchNotificationTypes } from './notification.js';
import { dismissAlert, finishLoading } from './dashboard.js';
import { fetchIntegrations } from './integeration.js';
import { fetchPortals } from './portal.js';

let currentTask = null;

function* sideFXForBrand() {
  yield takeLatest(types.SET_USER, finishLoading);
  yield takeLatest(types.SET_ALERT, dismissAlert);
}

function* sideFXForNonBrand() {
  yield takeLatest(types.SET_USER, fetchIntegrations);
  yield takeLatest(types.SET_USER, loadProjects);
  yield takeLatest(types.SELECT_PROJECT, updateUserDefaultProject);
  yield takeLatest(types.SELECT_PROJECT, fetchTemplates);
  yield takeLatest(types.SELECT_PROJECT, fetchTables);
  yield takeLatest(types.SET_PROJECT_TABLES, finishLoading);
  yield takeLatest(types.SET_ALERT, dismissAlert);
  yield takeLatest(types.UPDATE_USER, fetchNotifications);
  yield takeLatest(types.UPDATE_USER, fetchNotificationTypes);
  yield takeLatest(types.LOAD_NOTIFICATION_TYPES, fetchNotificationPreferences);
  yield takeLatest(types.UPDATE_USER, updateLocalStore);
  yield takeLatest(types.SET_USER, fetchPortals);
}

function* handleSetUser(action) {
  const user = action && action.payload;
  if (currentTask) {
    yield cancel(currentTask);
    currentTask = null;
  }

  if (!user || !user.type) return;

  if (user.type === 'BRAND') {
    currentTask = yield fork(sideFXForBrand);
    // run finishLoading for the current SET_USER so UI can stop loading
    yield fork(finishLoading);
    yield fork(fetchPortals);
  } else {
    currentTask = yield fork(sideFXForNonBrand);
    // Run handlers that should execute on the current SET_USER immediately
    yield fork(fetchIntegrations);
    yield fork(loadProjects);
    yield fork(fetchPortals);
  }
}

function* sideFX() {
  yield takeLatest(types.SET_USER, handleSetUser);
}

export default sideFX;
